import { render, staticRenderFns } from "./CombinationListSection.vue?vue&type=template&id=98da3210&scoped=true"
import script from "./CombinationListSection.vue?vue&type=script&lang=js"
export * from "./CombinationListSection.vue?vue&type=script&lang=js"
import style0 from "./CombinationListSection.vue?vue&type=style&index=0&id=98da3210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da3210",
  null
  
)

export default component.exports